import { green } from '@material-ui/core/colors';
import React, { ReactNode, useState } from 'react';
import Joyride from 'react-joyride';
import { padding } from 'styled-system';
import { ButtonHidden } from './TourContainer.styles';
import { TourContainerProps } from './TourContainer.types';
import TourContainerTooltip from './TourContainerTooltip';

const TourContainer = (props: TourContainerProps) => {
  const { children, message, target, defaultOpen, tourId, spotlightStyles, maxWidth } = props;
  const [run, setRun] = useState(!!defaultOpen);
  const targetName = `joyride-${target}`;
  if (tourId && localStorage.getItem(tourId)) {
    return <>{children}</>;
  }

  const steps = [
    {
      target: `.${targetName}`,
      content: message,
      disableBeacon: true,
    },
  ];
  const handleOpenTour = event => {
    event.stopPropagation();
    setRun(true);
  };
  const callback = ({ action }) => {
    if (action === 'close' && tourId) {
      localStorage.setItem(tourId, 'true');
    }
  };

  return (
    <>
      <ButtonHidden type="button" className={targetName} onClick={handleOpenTour} style={{ position: 'relative' }}>
        {children}
      </ButtonHidden>
      <div aria-hidden onClick={event => event.stopPropagation()}>
        <Joyride
          styles={spotlightStyles}
          scrollToFirstStep
          steps={steps}
          run={run}
          callback={callback}
          tooltipComponent={props => <TourContainerTooltip {...props} maxWidth={maxWidth} />}
          floaterProps={{
            disableAnimation: true,
            placement: 'bottom',
            hideArrow: true,
          }}
        />
      </div>
    </>
  );
};

export default TourContainer;
